import Dropzone from "dropzone";

if (document.getElementById('dropzone') !== null) {
	let dropZone = new Dropzone("#dropzone", {
		maxFiles: 1,
		acceptedFiles: 'application/pdf'
	});

	dropZone.on('complete', file => {
		if (file.xhr.status === 500) {
			window.toast(
				'error',
				`Er ging iets mis bij het uploaden. Er kunnen
				een aantal dingen aan de hand zijn:
				<ul>
					<li>Het bestand is te groot, stel de max_upload van de server bij, of:</li>
					<li>Je probeert een rapport te uploaden van een niet-ondersteund merk, óf</li>
					<li>Het serienummer van je reader is (nog) niet toegestaan</li>
				</ul>`
			)
			dropZone.removeFile(file)
			return
		}
		// No errors, continue
		stepPath(0)
		try {
			const response = JSON.parse(file.xhr.response)
			if (response.readerBrand === 'foxwell') {
				const readerSerial = prompt('Voer het serienummer van de reader in')
				fetch(`/index.php`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({
						action: 'checkSerial',
						readerSerial
					})
				}).then(r => { 
					if (r.status === 500) {
						window.toast(
							'error',
							'Sorry, dit serienummer is (nog) niet toegestaan om rapporten te verzenden.'
						)
						throw new Error('Invalid serial number entered')
					}
					processReport(response)
				})
			} else {
				processReport(response)
			}
			
		} catch (e) {
			alert(e)
		}
		dropZone.removeFile(file)
	})
}

window.hgen = {}
window.hgen.inputKeys = []

const processReport = values => {
	delete values.readerBrand
	for (const key in values) {
		document.querySelector(`#${key}`).value = values[key]
		window.hgen.inputKeys.push(key)
	}
	stepPath()
	deBlockUI()
	window.toast(
		'success',
		'Het rapport is verwerkt, controleer hieronder de gegevens' +
		' en pas deze waar nodig aan. Klik dan op \'Goedkeuren en versturen\''
	)
}

const blockUI = () => {
    [...document.getElementsByTagName('button')].forEach(button => {
        button.disabled = true
    })
    document.getElementById('loader').classList.add('active')
}

const deBlockUI = () => {
    [...document.getElementsByTagName('button')].forEach(button => {
        button.disabled = false
    })
    document.getElementById('loader').classList.remove('active')
}

const stepPath = (() => {
    let step = 0
    return function (stepOverride) {
        if (stepOverride !== undefined && isNaN(stepOverride)) {
            window.toast('error', 'Er ging iets mis.')
            throw new Error('Use a number when overriding the \'stepPath\' index, found ' + stepOverride)
        }
        step = !isNaN(stepOverride) ? stepOverride : step
        const steps = document.querySelectorAll('.slds-path__item')
        if ((step + 1) <= steps.length) {
            steps[step].classList.remove('slds-is-active', 'slds-is-current')
            steps[step].classList.add('slds-is-complete')
            step++
            if (steps[step] !== undefined) {
                steps[step].classList.add('slds-is-current')
            }
        } else {
            step = 0
            steps[step].classList.add('slds-is-current')
            steps.forEach(step => {
                step.classList.remove('slds-is-complete')
                step.classList.add('slds-is-active')
            })
        }
    }
})()

window.toast = (type, message) => {
	const html = `
    <div id="toast" class="slds-notify_container slds-is-fixed">
        <div class="slds-notify slds-notify_toast slds-theme_${type}" role="status">
            <span class="slds-assistive-text">${type}</span>
            <span class="slds-icon_container slds-icon-utility-${type} slds-m-right_small slds-no-flex slds-align-top" title="Description of icon when needed">
            <svg class="slds-icon slds-icon_small" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#${type}"></use>
            </svg>
            </span>
            <div class="slds-notify__content">
            <h2 class="slds-text-heading_small ">${message}</h2>
            </div>
            <div class="slds-notify__close">
            <button class="slds-button slds-button_icon slds-button_icon-inverse close-toast" title="Close">
                <svg class="slds-button__icon slds-button__icon_large" aria-hidden="true">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
                </svg>
                <span class="slds-assistive-text">Sluiten</span>
            </button>
            </div>
        </div>
    </div>`
    if (document.querySelector('#toast')) {
        document.body.removeChild(document.querySelector('#toast'));
    }

    const tmp = document.createElement('div')
    tmp.innerHTML = html
    document.body.appendChild(tmp.children[0])

    setTimeout(() => {
        if (document.querySelector('#toast')) {
            document.body.removeChild(document.querySelector('#toast'));
        }
    }, 8000)
}

window.sendData = async () => {
    stepPath()
    blockUI()
    window.toast('info', 'Gegevens worden verwerkt tot JWS token, dit kan even duren')
    const inputs = window.hgen.inputKeys.map(id => document.getElementById(id))
    const values = {'action': 'getJWS'}
    inputs.forEach(input => values[input.id] = input.value)
    const response = await fetch('index.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(values)
    })

    let jwt
    try {
        jwt = await response.text()
        window.toast('info', 'Gegevens verwerkt, token wordt naar RDW gestuurd')
        stepPath()
    } catch (e) {
        window.toast('error', 'Kon gegevens niet verwerken tot token')
        console.error(e)
        deBlockUI()
        return
    }
    const response2 = await fetch('index.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(
            {
                action: 'sendJWSToRDW',
                jwt
            }
        )
    })
    if (response2.status === 200) {
        window.toast('success', 'Gelukt, gegevens naar RDW gestuurd')
    } else {
        window.toast('error', 'Mislukt, kon gegevens niet naar RDW sturen, waarschijnlijk is het rapport ouder dan 750 uur.')
    }
    handleFullSend(inputs)
}

const handleFullSend = (inputs) => {
    stepPath()
    deBlockUI()
    stepPath() // Sets the steps back to zero
    inputs.forEach(input => {
        input.value = ''
        input.disabled = true
    })
}

const checkData = () => {
    document.querySelectorAll('input').forEach(input => input.classList.remove('slds-has-error'))
    const withError = window.hgen.inputKeys.find(key => {
        const input = document.querySelector(`#${key}`)
        const regex = new RegExp(input.getAttribute('regex'))
        return !regex.test(input.value)
    })
    if (withError !== undefined) {
        document.querySelector(`#${withError}`).classList.add('slds-has-error')
        window.toast('error', document.querySelector(`#${withError}`).getAttribute('regexerror'))
        return false
    }
    return true
}



window.addEventListener('click', e => {
    if (e.target.classList.contains('edit-field')) {
        e.target.previousElementSibling.removeAttribute('disabled')
    }
    if (e.target.classList.contains('close-toast')) {
        document.body.removeChild(document.querySelector('#toast'));
    }
    if (e.target.id === 'approve_and_send') {
        if (!checkData()) {
            return
        }
        sendData()
    }
    if (e.target.classList.contains('serial_activation_toggle')) {
        const serial = e.target.getAttribute('data-serial')
        const checkbox = e.target.parentElement.previousElementSibling
        const activated = !checkbox.checked
        setDeviceState(serial, activated)
    }
    if (e.target.classList.contains('save-new-serials')) {
        const newSerials = document.querySelector('#new-serials').value.split("\n")
        addnewSerials(newSerials)
    }
})

window.addEventListener('keyup', e => {
    if (e.target.id === 'serial-searcher') {
        const table = document.querySelector('#serials-table')
        const rows  = table.tBodies[0].querySelectorAll('tr')
        const term  = e.target.value.toLowerCase()
        rows.forEach(row => {
            row.classList.remove('hide-row')
            const serialCell = row.querySelector('.serial-cell')
            if (serialCell.innerText.toLowerCase().includes(term)) {
                return
            }
            row.classList.add('hide-row')
        })
    }
})

const setDeviceState = async (serial, activated) => {
    const response = await fetch(`/admin/index.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            action: 'setDeviceState',
            serial,
            activated
        })
    })
    if (response.status === 200) {
        window.toast(
            'success',
            `De status van het serienummer ${serial} is bijgewerkt`
        )
    }
}

const addnewSerials = async newSerials => {
    const response = await fetch(`/admin/index.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            action: 'addnewSerials',
            newSerials
        })
    })
    if (response.status === 201) {
        window.toast(
            'success',
            'Gelukt, de nieuwe serienummers zijn aangemaakt, de pagina wordt' +
            ' zometeen ververst'
        )
        setTimeout(() => {
            window.location = window.location
        }, 4000)
    }
    if (response.status === 500) {
        window.toast(
            'error',
            'Er ging iets mis'
        )
        const result = await response.text();
        window.toast(
            'info',
            result
        )
    }

}